// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container__8TIF7","fullScreen":"loading_fullScreen__3T5Au","halfScreen":"loading_halfScreen__2o0pd"};